<template>
    <div class="lesson-box">
        <div @click="goDetail(item.linkUrl)" v-for="(item, index) in goodList"
             :key="index"
        >
            <el-row class="wqel-row-out">
                <el-row class="wqel-row-title1">
                    <div>{{ item.bk1 }}</div>
                </el-row>
                <el-row :class="getClass(item.bk2)">
                    <div style="height: 7vh" v-html="item.bk2"></div>
                </el-row>
            </el-row>
        </div>
    </div>

</template>
<script>
    import {formatDate} from "@api/date.js";

    export default {
        name: "OldPeriodList",
        props: {
            goodList: {
                type: Array,
                default: () => []
            },
            isSort: {
                type: Boolean,
                default: true
            }
        },
        watch: {
            // console.log(this.$route)
            // // this.$route.path
            // '$route.path': function (newVal, oldVal) {
            //     console.log(newVal + "-----------------------------------" + oldVal);
            //
            // }
        },
        data: function () {
            return {
                url: '@assets/images/classChannel/3.jpg',
                wqxxUrl: require("@assets/images/classChannel/xxwq.jpg")
            };
        },
        methods: {
            // 商品详情跳转
            goDetail(url) {
                // var state = {
                //     title: "index",
                //     url: url
                // };
                // window.history.pushState(state, "index", location.href);
                window.location.href = url

            },
            getClass(value) {
                if(value.length<16){
                    return 'wqel-row-title3'
                }else{
                    return 'wqel-row-title2'
                }

            }
        },
        filters: {
            formatDateDay(time) {
                var date = new Date(time);
                return formatDate(date, "yyyy-MM-dd");
            }
        }
    };
</script>

<style>
    .lesson-text-line1 {
        text-align: left;
        margin-top: 1vh;
        font-size: 12px;
        margin-left: 5px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .lesson-box {
        /*margin-left: 0vw;*/
        /*margin-right: 0vw;*/
        /*margin-top: 1vh;*/
        /*padding: 1px;*/
        margin: 0px;
    }

    .wjlesson-img {
        margin-top: 1vh;
        margin-left: 1px;
        width: 91%;
        height: 10%;
        border-radius: 5px;
        background-image: url("../assets/images/classChannel/xxwq.jpg");
    }

    .wqel-row-out {
        /*height: 16.5vh;*/
        margin: 1vh;
        height: 17vh;
        border-radius: 8px;
        background-image: url("../assets/images/classChannel/xxwq.jpg");
        position: relative;
        text-align: center;
        background-size: 100% 100%; /*按比例缩放*/
        /*padding: 1vw;*/
    }

    .wqel-row-title1 {
        /*height: 16.5vh;*/
        font-size: 18px !important;
        letter-spacing: 6px;
        font-weight: bold;
        color: gold;
        margin: 2vh;
        border-radius: 8px;
        position: relative;
        text-align: center;
        /*padding: 1vw;*/
    }

    .wqel-row-title2 {
        /*height: 16.5vh;*/
        font-size: 13px !important;
        /*display: flex;*/
        /*!*实现垂直居中*!*/
        /*align-items: center;*/
        /*!*实现水平居中*!*/
        /*justify-content: center;*/
        letter-spacing: 2px;
        margin: 3vh;
        color: white;
        position: absolute;
        border-radius: 8px;
        position: relative;
        text-align: center;
        /*padding: 1vw;*/
    }

    .wqel-row-title3 {
        /*height: 16.5vh;*/
        font-size: 15px !important;
        /*display: flex;*/
        /*!*实现垂直居中*!*/
        /*align-items: center;*/
        /*!*实现水平居中*!*/
        /*justify-content: center;*/
        letter-spacing: 2px;
        margin: 4vh;
        color: white;
        position: absolute;
        border-radius: 8px;
        position: relative;
        text-align: center;
        /*padding: 1vw;*/
    }


    .el-row-in {
        margin-bottom: 5vh;
    }

    .old-tag {
        position: absolute;
        margin-left: 4.5%;
        width: 91%;
        height: 18.6%;
    }

    .last-img {
        height: 20vh;
        width: 100%;
        position: relative;
        text-align: center;
        background-size: 100% 100%; /*按比例缩放*/
        background-image: url("../assets/images/classChannel/3.jpg");
    }
</style>
